export { default } from './CmsAuthenticator';
